import { render, staticRenderFns } from "./YFormatAgentArea.vue?vue&type=template&id=18539800&scoped=true&"
import script from "./YFormatAgentArea.vue?vue&type=script&lang=js&"
export * from "./YFormatAgentArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18539800",
  null
  
)

export default component.exports